import { IconButton } from '@material-ui/core';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { Typography } from '@mui/material';
import axios, { AxiosError, AxiosResponse } from 'axios';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { ReactComponent as SwitchOff } from '../../assets/icons/switch-off.svg';
import { ReactComponent as SwitchOn } from '../../assets/icons/switch-on.svg';
import vl from '../../assets/icons/vl.svg';
import { AssessmentPanel, ViewType } from '../../components/Assessment/AssesmentPanel.component';
import { CommentTypeId, IComment } from '../../components/Comments/Comments.types';
import { CommentsOutsidePage } from '../../components/Comments/CommentsOutsidePage/CommentsOutsidePage.component';
import Navbar from '../../components/Layout/Navbar/Navbar.component';
import { NewMessageModal } from '../../components/NewMessage/NewMessageModal.component';
import { ExaminerBlocked } from '../../components/Prompt/ExaminerBlocked.component';
import LeavePromptRedirectionBlock from '../../components/Prompt/LeavePrompt/LeavePromptRedirectionBlock.component';
import { getSheetCodeWithTaskGroupName } from '../../components/Prompt/UnreadMessage/helpers';
import {
  unreadMessageActionType,
  UnreadMessagePrompt,
} from '../../components/Prompt/UnreadMessage/UnreadMessagePrompt.component';
import { SessionSuspended } from '../../components/SessionSuspended/SessionSuspended.component';
import { SnackbarDownload } from '../../components/SnackbarDownload/SnackbarDownload.component';
import { AnnotationTool } from '../../components/Solution/AnnotationTool.component';
import { AdjustmentsDefined } from '../../components/Solution/Menu/AdjustmentsDefined.component';
import { AssignToSampleAssessmentGroup } from '../../components/Solution/Menu/AssignToSampleAssessmentGroup/AssignToSampleAssessmentGroup.component';
import { ChipButton } from '../../components/Solution/Menu/ChipButton.component';
import { CloseIcon } from '../../components/Solution/Menu/CloseIcon.component';
import { Download } from '../../components/Solution/Menu/Download.component';
import { Menu } from '../../components/Solution/Menu/Menu.component';
import { Nav } from '../../components/Solution/Menu/Nav.component';
import { ProcessQualification } from '../../components/Solution/Menu/ProcessQualification/ProcessQualification.component';
import { SwitchView } from '../../components/Solution/Menu/SwitchView.component';
import { Preview } from '../../components/Solution/Preview.component';
import { rotateAngleValue, zoomFactorValue, zoomFactorValues } from '../../components/Solution/Preview.types';
import { SideToolbar } from '../../components/Solution/SideToolbar.component';
import {
  SolutionExamSheetPage,
  SolutionImageZoneWithImgData,
} from '../../components/Solution/SolutionZoneList/SolutionZoneList.types';
import { Thumbnails } from '../../components/Solution/Thumbnails.component';
import { Toolbar } from '../../components/Solution/Toolbar.component';
import { SpecialCaseIcons } from '../../components/SpecialCaseIcons/SpecialCaseIcons.component';
import {
  canUserAssessAfterSendingBack,
  getCriterionFromTasks,
  getTaskFromTasks,
  isCommentForScoreRequired,
} from '../../Context/helpers';
import { useLayoutContext } from '../../Context/Layout.context';
import { useScoring } from '../../Context/Scoring.context';
import useDocumentTitle from '../../hooks/DocumentTitle/documentTitle';
import usePermission, { UserPermission } from '../../hooks/usePermission';
import useSessionUser from '../../hooks/useSessionUser';
import {
  AnnotationDefinition,
  AnnotationOnImage,
  AnnotationsCriterionDTO,
  AnnotationSequence,
  AnnotationsForORGZ,
  AnnotationVersion,
  AnnotationVersionsForORGZ,
} from '../../models/annotation.types';
import {
  DownloadExamTaskGroupSolution,
  ExamScoringSchema,
  ExamTask,
  ExamTaskGroupSolutionDownloadResult,
  ExamTaskGroupSolutionScoreShelfResponse,
  ExamTaskGroupSolutionWithTasks,
  ExamTasksCoordinates,
} from '../../models/assessment.types';
import { ConversationType, Priority } from '../../models/communication.types';
import {
  DownloadType,
  ExaminerFunction,
  ExamTaskGroupSolutionsNavigation,
} from '../../pages/Assessment/Assessment.types';
import { getAnnotationDefinitions } from '../../services/admin/settings/annotations.service';
import { hasUnreadMessages } from '../../services/communication/communication.service';
import { getExamTaskGroupSolutionStatus } from '../../services/distribution/distribution.service';
import { getExaminerById } from '../../services/examiners/examiners.service';
import { Examiner } from '../../services/examiners/examiners.types';
import {
  getExamTaskSolutionsIdList,
  getExamTasksWithCriteria,
  getIsTraingSession,
} from '../../services/exams/assessmentSession/assessments.service';
import {
  AssessmentSessionProcessTypeId,
  ExamTaskGroupSolution,
  ExamTaskGroupSolutionStatus,
  Status,
} from '../../services/exams/assessmentSession/assessments.types';
import { isExaminerBlockedInSession } from '../../services/exams/examiningTeam/examiningTeam.service';
import {
  createExamTaskGroupSolutionScoreShelf,
  getAnnotations,
  getAnnotationVersions,
  getComments,
  getCriterionAnnotation,
  getExamTaskGroup,
} from '../../services/exams/examTaskGroup/examTaskGroup.service';
import { getSheetGradeRuleName } from '../../services/exams/sessions/sessions.service';
import {
  getExamScoringSchemaImageZone,
  getExamTaskPages,
  getSolutionCardDetails,
  getTaskImageZones,
} from '../../services/images/images.service';
import { getExamTaskGroupSolutionIds } from '../../services/scans/examTaskGroupSolution/examTaskGroupSolution.service';
import {
  SampleAssessmentExamTaskGroupSolutionIdsResponse,
  SampleAssessmentExamTaskGroupSolutionIdsResponseWithSchoolCode,
  SheetInfoDetails,
} from '../../services/scans/examTaskGroupSolution/examTaskGroupSolution.types';
import { getExamTaskGroupSolutionScoreIds } from '../../services/scoring/scoring.service';
import { getExamTaskGroupSolutionScoreStatus } from '../../services/scoringModel/scoringModel.service';
import { SampleExamTaskGroupSolutionScoreState } from '../../services/scoringModel/scoringModel.types';
import { processIsNotAccessible, redirectionToProcess } from '../../utils/assessmentSessionProcess';
import EnvWindow from '../../utils/env';
import { zoomIn, zoomOut } from '../../utils/zoom';
import DownloadLimitModal from '../Assessment/Modals/DownloadLimitModal.component';
import { AssessmentSessionState, SampleAssessmentSessionState } from '../Dashboard/Dashboard.types';
import { imageZone } from '../Sessions/ImageZonesEditor/ZonesList/ZonesList.types';
import {
  getAssessmentSampleAssessmentGroupSolutionUrl,
  getSampleAssessmentGroupSolutionAssignmentUrl,
  getSampleAssessmentRepositoryUrl,
  getSampleAssessmentUrl,
  getSolutionUrl,
} from './../../utils/routerUrls';
import { useStyles } from './Solution.styles';
import TooltipOne from '../../components/TooltipOne/TooltipOne.component';
import CardsDownloaderContainer from '../../components/CardsDownloaderContainer.component';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { ContextualHelp } from '../../components/ContextualHelp/ContextualHelp.component';
import { contextualHelpActions } from '../../reducers/contextualHelpReducer/contextualHelpSlice';
import { SignalRContext } from '../../Context/SignalR.context';
import { CallbackMethodNames } from '../../models/signalR.types';
import { TabExamTaskGroupSolutionScore } from '../../reducers/assessmentSessionReducer/assessmentSessionSlice';
import TabsBar from '../../components/Solution/TabsBar.component';
import { fillBlue } from '../../utils/contrastSvgAttributes';
import _ from 'lodash';
import TooltipOneComponent from '../../components/TooltipOne/TooltipOne.component';
import { getFlags } from '../../services/admin/settings/systemSettings.service';
import { FlagType } from '../../components/SystemSettings/SystemFlags/Subcomponents/Flag.types';
import { FlagsTableItem } from '../../components/SystemSettings/SystemFlags/Subcomponents/FlagsTableItem.component';
import { adjustLayout_dangerously } from './solutionUtils';
import { SkipLink } from '../../components/SkipLink/SkipLink.component';

export enum SolutionViewMode {
  assessment,
  sampleAssessmentGroupAssignment,
  assessmentSampleAssessmentGroup,
}

export type PreviewType = 'card' | 'solution';

interface IScoreRequiringCurrentUserComment {
  partialScoreId: string;
  score: number;
}

interface SolutionProps {
  mode: SolutionViewMode;
  schoolId?: string;
  rgzId?: string;
  isTabActive?: boolean;
  activeTabIndex?: number;
  tabs?: TabExamTaskGroupSolutionScore[];
  onChangeTab?: (value: number) => void;
  tabIndexesWithUnsavedShelf?: number[];
  onShelfAssessingChange?: (value: boolean) => void;
  isGlobalFullScreen?: boolean;
  onFullScreenChange?: (value: boolean) => void;
}

const cardWidth = 598;
const TAB_HEIGHT = 48;

const Solution: React.FC<SolutionProps> = (props) => {
  const assessmentSession = useSelector((state: RootState) => state.assessmentSession.assessmentSession);

  const {
    examTaskGroupSolutionWithTasks,
    activeCriterion,
    activeTask,
    activeScore,
    orgzId,
    examinerId,
    assessmentSessionId,
    processTypeId,
    deskId,
    examinerFunction,
    isAnyModalOpened: isAnyScoringModalOpened,
    isTrainingSession,
    loadTasks,
    onBeforeScoreStore,
    onUpdateScore,
    onDeleteTaskScore,
    updateIsCommentForCurrentScoreProvided,
    getSetupsForcingDependentCriterionReset,
    getCriterionFromActiveTask,
    updateScoreInCriterion,
    activateCriterion,
    setActiveTask,
    examTaskGroupSolutionScoreVersionId,
    setExamTaskGroupSolutionScoreVersionId,
    isSpecialCaseReported,
    setIsTrainingSession,
    isForcedCommentChanged,
    setIsForcedCommentChanged,
    isCommentUpdate,
    setIsCommentUpdate,
  } = useScoring();

  const { user, userAssessmentSessionInfo } = useSessionUser();
  useDocumentTitle(`Ocena rozwiązań grupy zadań: ${props.rgzId ?? orgzId}`);

  const examTaskSolutionsTabsMode = props.tabs && props.tabs.length > 0;
  const isShelfAssessing = !!examTaskGroupSolutionScoreVersionId;

  if (!assessmentSession) {
    return <Redirect to="/dashboard" />;
  }

  const userFunction: ExaminerFunction | undefined = [
    SolutionViewMode.sampleAssessmentGroupAssignment,
    SolutionViewMode.assessmentSampleAssessmentGroup,
  ].includes(props.mode)
    ? assessmentSession?.examinerFunction //this one contains PZWO and CZWO functions
    : userAssessmentSessionInfo?.function || assessmentSession?.examinerFunction;

  if (
    props.mode === SolutionViewMode.assessment &&
    userFunction === ExaminerFunction.CZE &&
    processTypeId !== undefined
  ) {
    if (processIsNotAccessible(processTypeId)) {
      return <Redirect to="/dashboard" />;
    }
  }

  const classes = useStyles();
  const history = useHistory();

  const { openAlert, showLoader, isAnyDropdownOpen } = useLayoutContext();

  const [examTasksCoordinates, setExamTasksCoordinates] = useState<ExamTasksCoordinates>();
  const [pagesUrls, setPagesUrls] = useState<string[]>([]);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [isSidebarVisible, setIsSidebarVisible] = useState<boolean>(false);
  const [isToolbarOpen, setIsToolbarOpen] = useState<boolean>(false);
  const [isThumbnailsOpen, setIsThumbnailsOpen] = useState<boolean>(false);
  const [previewType, setPreviewType] = useState<PreviewType>('solution');

  const [cardId, setCardId] = useState<string>();
  const [zoomFactor, setZoomFactor] = useState<zoomFactorValue>(zoomFactorValue.screenWidth);
  const [rotateAngle, setRotateAngle] = useState<rotateAngleValue>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [examiner, setExaminer] = useState<string>('');
  const [viewSinglePage, setViewSinglePage] = useState<boolean>(true);
  const [viewTwoPages, setViewTwoPages] = useState<boolean>(false);
  const [isFullscreen, setIsFullscreen] = useState<boolean>(false);
  const [examTaskGroupSolutionsList, setExamTaskGroupSolutionsList] = useState<ExamTaskGroupSolution[]>([]);
  const [notAssessedExamTaskGroupSolutionsList, setNotAssessedExamTaskGroupSolutionsList] = useState<
    ExamTaskGroupSolution[]
  >([]);
  const [examinerName, setExaminerName] = useState<string>('');
  const [isSnackbarVisible, setIsSnackbarVisible] = useState<boolean>(false);
  const [snackbarMessage, setSnackbarMessage] = useState<string>('');
  const [isExaminerBlocked, setIsExaminerBlocked] = useState<boolean>(false);
  const [isExaminerBlockedPromptOpen, setIsExaminerBlockedPromptOpen] = useState<boolean>(false);
  const [fileExamSheetName, setFileExamSheetName] = useState<string | null>(null);
  const [examTaskGroupSolutionStatus, setExamTaskGroupSolutionStatus] = useState<ExamTaskGroupSolutionStatus>();
  const [viewType, setViewType] = useState<ViewType>('cards');
  const [schooldCode, setSchoolCode] = useState<string>();
  const [sampleAssessmentSelectedProcess, setSampleAssessmentSelectedProcess] =
    useState<AssessmentSessionProcessTypeId | null>(null);
  const [sampleExamTaskGroupSolutionScoreState, setSampleExamTaskGroupSolutionScoreState] =
    useState<SampleExamTaskGroupSolutionScoreState | null>(null);
  const examSheetPagesBuffer = useRef<SolutionExamSheetPage[]>([]);
  const examSheetPages = useRef<SolutionExamSheetPage[]>([]);
  const [examSheetPagesLoaded, setExamSheetPagesLoaded] = useState<boolean>(false);
  const [imageZones, setImageZones] = useState<SolutionImageZoneWithImgData[]>([]);
  const [imageZonesLoaded, setImageZonesLoaded] = useState<boolean>(false);
  const [downloadLimitModalOpen, setDownloadLimitModalOpen] = useState<boolean>(false);
  const [isReadOnly, setIsReadOnly] = useState<boolean>(false);
  const [comments, setComments] = useState<IComment[] | undefined>(undefined);
  const [currentCommentsOutsidePage, setCurrentCommentsOutsidePage] = useState<IComment[]>([]);
  const [isNewCommentDragging, setIsNewCommentDragging] = useState<boolean>(false);
  const [isCommentsOpen, setIsCommentsOpen] = useState<boolean>(false);
  const [isAnnotationsOpen, setIsAnnotationsOpen] = useState<boolean>(true);
  const [activeAnnotationId, setActiveAnnotationId] = useState<string>('');
  const prevActiveAnnotationId = useRef<string>('');
  const [isAnnotationDocked, setIsAnnotationDocked] = useState<boolean>(true);
  const [annotationDefinitions, setAnnotationDefinitions] = useState<AnnotationDefinition[]>([]);
  const [annotations, setAnnotations] = useState<AnnotationOnImage[] | null>(null);
  const [annotationVersions, setAnnotationVersions] = useState<AnnotationVersion[] | null>(null);
  const [annotationsCriterion, setAnnotationsCriterion] = useState<AnnotationSequence[] | null>([]);
  const [isSorted, setIsSorted] = useState<boolean>(false);

  const [annotationsVisible, setAnnotationsVisible] = useState<boolean>(true);
  const [commentsOnPageVisible, setCommentsOnPageVisible] = useState<boolean>(true);
  const [allCommentsOnPageVisible, setAllCommentsOnPageVisible] = useState<boolean>(false);
  const [isScoringAdjusted, setIsScoringAdjusted] = useState<boolean>(false);
  const [messageModal, setMessageModal] = useState<{ open: boolean; type: 'standard' | 'helpdesk' | 'orgzMessage' }>({
    open: false,
    type: 'orgzMessage',
  });
  const [recipient, setRecipient] = useState<Examiner>();
  const [isSpecialCaseModalOpen, setIsSpecialCaseModalOpen] = useState<boolean>(false);
  const [flags, setFlags] = useState<FlagType[]>([]);
  const [isAssignFlagsModalOpen, setIsAssignFlagsModalOpen] = useState(false);
  const [isTooltipOpen, setIsTooltipOpen] = useState<boolean>(false);
  const [isAnnotationSelected, setIsAnnotationSelected] = useState<boolean>(false);
  const [isSkipLink, setIsSkipLink] = useState<boolean>(false);
  const [cardAbsoluteId, setCardAbsoluteId] = useState<string | null>(null);

  const [unreadMessagePrompt, setUnreadMessagePrompt] = useState<{
    isOpen: boolean;
    actionType: unreadMessageActionType;
    unreadConversationType: ConversationType;
  }>({ isOpen: false, actionType: 'download', unreadConversationType: ConversationType.Standard });

  const [scoresRequiringCurrentUserComment, setScoresRequiringCurrentUserComment] = useState<
    IScoreRequiringCurrentUserComment[]
  >([]);

  const isAnyModalOpened =
    isAnyScoringModalOpened ||
    messageModal.open ||
    unreadMessagePrompt.isOpen ||
    downloadLimitModalOpen ||
    isSpecialCaseModalOpen ||
    isAssignFlagsModalOpen;

  useEffect(() => {
    getFlags().then(
      (result: FlagType[]) => setFlags(result),
      () => openAlert('get_error'),
    );
  }, []);

  useEffect(() => {
    if (previewType === 'solution') {
      setRotateAngle(0);
    }
  }, [previewType]);

  useEffect(() => {
    props.onShelfAssessingChange && props.onShelfAssessingChange(isShelfAssessing);
  }, [isShelfAssessing]);

  const canvasElementRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    if (userFunction !== undefined && userFunction !== ExaminerFunction.CZE && examiner) {
      getExaminerById(examiner).then((res) => {
        setExaminerName(`(E) ${res.data.firstName.charAt(0)}.${res.data.lastName}`);
        setRecipient(res.data);
      });
    }
  }, [examiner]);

  const refreshExamTasks = (isScoreVersionIdUndefined?: boolean) => {
    if (cardId) {
      if (
        (props.mode === SolutionViewMode.assessment ||
          props.mode === SolutionViewMode.assessmentSampleAssessmentGroup) &&
        orgzId
      ) {
        getExamTasksWithCriteria(
          orgzId,
          isScoreVersionIdUndefined ? undefined : examTaskGroupSolutionScoreVersionId,
        ).then(
          (response: ExamTaskGroupSolutionWithTasks) => {
            if (userFunction === ExaminerFunction.CZE && response.examTaskGroupSolutionScoreState === Status.New) {
              //ExamTaskGroupSolution was initially opened by an examiner so its status will be changed in the background to Status.Open async
              //UI can reflect this change immediately as it is required for sendback button to be active
              response.examTaskGroupSolutionScoreState = Status.Open;
            }
            loadTasks(response);
            setIsReadOnly(response.isReadOnly);
            setIsScoringAdjusted(response.isScoringAdjusted);
            if (response.examTasksCriteria.length > 0) {
              setIsSidebarVisible(true);
            }
          },
          () => {
            setIsSidebarVisible(false);
          },
        );
      } else if (
        props.mode === SolutionViewMode.sampleAssessmentGroupAssignment &&
        examTaskGroupSolutionWithTasks === null
      ) {
        getExamTaskGroup().then((result: ExamTaskGroupSolutionWithTasks) => {
          loadTasks(result);
        });
      }
    }
  };

  useEffect(() => {
    if (!isCommentUpdate) {
      showLoader(false);
    }
  }, [isCommentUpdate]);

  const refreshComments = (orgzId: string, examTaskGroupSolutionScoreVersionId?: string) => {
    if (isForcedCommentChanged || isCommentUpdate) return;
    setAllCommentsOnPageVisible(false);
    showLoader(true);
    getComments(orgzId, examTaskGroupSolutionScoreVersionId)
      .then(
        (response: AxiosResponse<IComment[]>) => {
          const data = response.data;
          setComments(data);
        },
        () => {
          console.error();
        },
      )
      .finally(() => {
        showLoader(false);
      });
  };

  const refreshAnnotations = (orgzId: string, examTaskGroupSolutionScoreVersionId?: string) => {
    getAnnotations(orgzId, examTaskGroupSolutionScoreVersionId).then(
      (response: AxiosResponse<AnnotationsForORGZ>) => {
        const data = response.data;
        setAnnotations(data.dtos);
      },
      () => {
        console.error();
      },
    );
    getAnnotationVersions(orgzId).then(
      (response: AxiosResponse<AnnotationVersionsForORGZ>) => {
        const data = response.data;
        setAnnotationVersions(data);
      },
      () => {
        console.error();
      },
    );
  };

  const resetPages = () => {
    setPagesUrls([]);
    setComments(undefined);
    setAnnotations(null);
    setAnnotationVersions(null);
    examSheetPages.current = [];
    setAllCommentsOnPageVisible(false);
    setExamTaskGroupSolutionScoreVersionId(undefined);
  };

  useEffect(() => {
    console.log('Refresh pages', { orgzId, cardId, mode: props.mode });
    if ((!orgzId || !cardId) && props.mode !== SolutionViewMode.sampleAssessmentGroupAssignment) {
      return;
    }
    resetPages();
    refreshExamTasks(true);
    if (props.mode !== SolutionViewMode.sampleAssessmentGroupAssignment && orgzId) {
      refreshComments(orgzId);
      refreshAnnotations(orgzId);
    }
  }, [orgzId, props.mode, examinerId, assessmentSessionId, cardId, userFunction]);

  const updateExamTaskGroupSolutionsListForSampleAssessment = (responseData: SheetInfoDetails[]) => {
    setExamTaskGroupSolutionsList(
      responseData.map((sheetInfo) => {
        return {
          id: sheetInfo.examTaskGroupSolutionId,
          sheetId: sheetInfo.taskSolutionSheetId,
          examinerId: sheetInfo.examinerId,
          examTaskGroupSolutionScoreId: sheetInfo.examTaskGroupSolutionScoreId,
        };
      }),
    );
  };

  const refreshNavigation = () => {
    if (
      userFunction !== undefined &&
      props.mode === SolutionViewMode.assessment &&
      assessmentSessionId &&
      deskId &&
      examinerFunction !== undefined &&
      processTypeId !== undefined
    ) {
      if (!examTaskSolutionsTabsMode) {
        getExamTaskSolutionsIdList(assessmentSessionId, deskId, examinerFunction, processTypeId).then((res) => {
          setExamTaskGroupSolutionsList(res.examTaskGroupSolutions);
        });
      } else if (props.tabs && props.activeTabIndex !== undefined && props.tabs.length > props.activeTabIndex - 1) {
        setExamTaskGroupSolutionsList([props.tabs[props.activeTabIndex]]);
      }
      getExamTaskSolutionsIdList(assessmentSessionId, deskId, examinerFunction, processTypeId, true).then((res) => {
        setNotAssessedExamTaskGroupSolutionsList(res.examTaskGroupSolutions);
      });
    } else if (props.mode === SolutionViewMode.sampleAssessmentGroupAssignment && props.schoolId) {
      getExamTaskGroupSolutionIds(props.schoolId).then(
        (res: SampleAssessmentExamTaskGroupSolutionIdsResponseWithSchoolCode) => {
          setSchoolCode(res.schoolCode);
          updateExamTaskGroupSolutionsListForSampleAssessment(res.sheetInfo);
        },
      );
    } else if (props.mode === SolutionViewMode.assessmentSampleAssessmentGroup) {
      getExamTaskGroupSolutionScoreIds(examinerId, examinerFunction).then(
        (res: SampleAssessmentExamTaskGroupSolutionIdsResponse) => {
          updateExamTaskGroupSolutionsListForSampleAssessment(res.sheetInfo);
        },
      );
    }
  };

  useEffect(() => {
    refreshNavigation();
  }, [
    examinerId,
    processTypeId,
    assessmentSessionId,
    deskId,
    userFunction,
    orgzId,
    props.rgzId,
    props.schoolId,
    props.activeTabIndex,
  ]);

  const refreshSampleExamTaskGroupSolutionScoreState = (orgzId?: string) => {
    if (orgzId)
      getExamTaskGroupSolutionScoreStatus(orgzId).then((res: AxiosResponse<SampleExamTaskGroupSolutionScoreState>) => {
        setSampleExamTaskGroupSolutionScoreState(res.data);
      });
  };

  useEffect(() => {
    if (
      examTaskGroupSolutionWithTasks?.examTaskGroupSolutionScoreState !== undefined &&
      props.mode === SolutionViewMode.assessmentSampleAssessmentGroup
    ) {
      refreshSampleExamTaskGroupSolutionScoreState(orgzId);
    }
  }, [examTaskGroupSolutionWithTasks?.examTaskGroupSolutionScoreState, props.mode, orgzId]);

  const isInAnyAssessmentMode: boolean =
    props.mode === SolutionViewMode.assessment || props.mode === SolutionViewMode.assessmentSampleAssessmentGroup;

  const examTaskGroupSolutionsNavigation: ExamTaskGroupSolutionsNavigation = useMemo(() => {
    let prevId: string | null = null;
    let nextId: string | null = null;
    let found = false;
    examTaskGroupSolutionsList.forEach((item: ExamTaskGroupSolution) => {
      if (!found && item.id !== orgzId && item.id !== props.rgzId) prevId = item.id;
      else if (item.id === orgzId || item.id === props.rgzId) {
        setCardAbsoluteId(item.id);
        setCardId(item.sheetId);
        if (isInAnyAssessmentMode && item.examinerId) setExaminer(item.examinerId);
        found = true;
      } else if (!nextId) {
        nextId = item.id;
      }
    });
    return {
      prevId,
      nextId,
      firstId: examTaskGroupSolutionsList.length ? examTaskGroupSolutionsList[0].id : null,
      lastId: examTaskGroupSolutionsList.length
        ? examTaskGroupSolutionsList[examTaskGroupSolutionsList.length - 1].id
        : null,
    };
  }, [orgzId, props.rgzId, examTaskGroupSolutionsList]);

  const notAssessedExamTaskGroupSolutionsNavigation: ExamTaskGroupSolutionsNavigation = useMemo(() => {
    let prevId: string | null = null;
    let nextId: string | null = null;
    let found = false;
    notAssessedExamTaskGroupSolutionsList.forEach((item: ExamTaskGroupSolution) => {
      if (!found && item.id !== orgzId) prevId = item.id;
      else if (item.id === orgzId) {
        setCardAbsoluteId(item.id);
        setCardId(item.sheetId);
        if (isInAnyAssessmentMode && item.examinerId) setExaminer(item.examinerId);
        found = true;
      } else if (!nextId) {
        nextId = item.id;
      }
    });
    return {
      prevId,
      nextId,
      firstId: notAssessedExamTaskGroupSolutionsList.length ? notAssessedExamTaskGroupSolutionsList[0].id : null,
      lastId: notAssessedExamTaskGroupSolutionsList.length
        ? notAssessedExamTaskGroupSolutionsList[notAssessedExamTaskGroupSolutionsList.length - 1].id
        : null,
    };
  }, [orgzId, notAssessedExamTaskGroupSolutionsList]);

  useEffect(() => {
    if (assessmentSessionId) {
      getSheetGradeRuleName(assessmentSessionId)
        .then((res) => {
          if (res.data && res.status === 200) {
            setFileExamSheetName(res.data.toString());
          } else {
            setFileExamSheetName(null);
          }
        })
        .catch(() => {
          setFileExamSheetName(null);
        });
    }
  }, [assessmentSessionId]);

  const handleToolbarOpen = () => {
    setIsToolbarOpen(!isToolbarOpen);
    setIsThumbnailsOpen(false);
  };

  const handleThumbnailsOpen = () => {
    setIsThumbnailsOpen(!isThumbnailsOpen);
    setIsToolbarOpen(false);
  };

  const handleDocked = (value: boolean) => {
    setIsAnnotationDocked(value);
  };

  const handleZoomChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setZoomFactor(event.target.value as zoomFactorValue);
    isAnyDropdownOpen.current = false;
  };

  const handleZoomIn = useCallback(() => {
    zoomIn(zoomFactor, cardWidth, canvasElementRef, setZoomFactor);
  }, [zoomFactor]);

  const handleZoomOut = useCallback(() => {
    zoomOut(zoomFactor, cardWidth, canvasElementRef, setZoomFactor);
  }, [zoomFactor]);

  const handleRotateLeft = () => {
    setRotateAngle((rotateAngle !== 0 ? rotateAngle - 90 : 270) as rotateAngleValue);
  };

  const handleRotateRight = () => {
    setRotateAngle((rotateAngle !== 270 ? rotateAngle + 90 : 0) as rotateAngleValue);
  };

  const handleSidebarVisibility = () => {
    setIsSidebarVisible(!isSidebarVisible);
    setIsTooltipOpen(false);
  };

  useEffect(() => {
    if (props.isGlobalFullScreen !== undefined) {
      setIsFullscreen(props.isGlobalFullScreen);
      setIsSidebarVisible(props.isGlobalFullScreen);
    }
  }, [props.isGlobalFullScreen]);

  const handleFullscreen = () => {
    setIsFullscreen((state) => !state);
    setIsSidebarVisible(isFullscreen ? true : false);
    props.onFullScreenChange && props.onFullScreenChange(!isFullscreen);
  };

  const handleSwitchView = () => {
    setPreviewType((prevState) => (prevState === 'card' ? 'solution' : 'card'));
  };

  const getPages = (activeTask: ExamTask) => {
    getExamTaskPages(activeTask.taskId).then((result: ExamTasksCoordinates) => {
      if (result) {
        setExamTasksCoordinates(result);
        if (result.examSheetPages.length) {
          setCurrentPage(Number(result.examSheetPages[0].pageNumber));
          //Constructor added as API returns pageNumber as string
        } else {
          setCurrentPage(1);
        }
      } else {
        setCurrentPage(1);
      }
    });
  };

  const handleDownloadFinish = async (downloadType: DownloadType, response: DownloadExamTaskGroupSolution) => {
    switch (response.solutionDownloadResult) {
      case ExamTaskGroupSolutionDownloadResult.SingleSolution:
      case ExamTaskGroupSolutionDownloadResult.FilledUpToLimits:
        setIsSnackbarVisible(true);
        setSnackbarMessage(
          response.solutionDownloadResult === ExamTaskGroupSolutionDownloadResult.FilledUpToLimits
            ? `Pobrano ${response.solutions.length} kart`
            : 'Karta pobrana',
        );
        refreshNavigation();
        break;
      case ExamTaskGroupSolutionDownloadResult.NoneExceededLimits:
        setExamTaskGroupSolutionStatus(ExamTaskGroupSolutionStatus.NoneExceededLimits);
        setDownloadLimitModalOpen(true);
        break;
      case ExamTaskGroupSolutionDownloadResult.NoneNoMoreSolutions:
        setExamTaskGroupSolutionStatus(ExamTaskGroupSolutionStatus.NoneNoMoreSolutions);
        setDownloadLimitModalOpen(true);
        break;
      case ExamTaskGroupSolutionDownloadResult.NoneExaminerBlocked:
        setIsExaminerBlocked(true);
        setIsExaminerBlockedPromptOpen(true);
        setExamTaskGroupSolutionStatus(ExamTaskGroupSolutionStatus.NoneExaminerBlocked);
        break;
      case ExamTaskGroupSolutionDownloadResult.NoneProcessFinished:
        setExamTaskGroupSolutionStatus(ExamTaskGroupSolutionStatus.NoneProcessFinished);
        break;
      case ExamTaskGroupSolutionDownloadResult.ExaminerShouldReadMessages:
        hasUnreadMessages(Priority.High)
          .then((result) => {
            if (result.status === 200) {
              setUnreadMessagePrompt({
                isOpen: true,
                actionType: 'download',
                unreadConversationType: result.data,
              });
            }
          })
          .catch(() => openAlert('error'));
        break;
      default:
        console.error('Other result on download: ' + response.solutionDownloadResult);
        break;
    }
  };

  const setMultiplePagesView = (singleValue: boolean, twoValue: boolean) => {
    setViewSinglePage(singleValue);
    setViewTwoPages(twoValue);
  };

  const handleMultiplePagesView = (option: number) => {
    if (option === 1) {
      setMultiplePagesView(true, false);
    } else if (option === 2) {
      setMultiplePagesView(false, true);
    }
  };

  useEffect(() => {
    console.log('Card id', cardId);
    if (cardId) {
      getSolutionCardDetails(cardId).then((result) => {
        const pages: string[] = Array.from(result.pages.values()).map(
          (item) => `${EnvWindow.REACT_APP_IMAGES_API_URL}/ExamSheetPageImage/page/${item.pageId}`,
        );
        setExamSheetPagesLoaded(false);
        setPagesUrls(pages);
        setTotalPages(result.pages.length);
      });
      if (
        processTypeId !== undefined &&
        props.mode !== SolutionViewMode.sampleAssessmentGroupAssignment &&
        props.mode !== SolutionViewMode.assessmentSampleAssessmentGroup
      ) {
        getExamTaskGroupSolutionStatus(+processTypeId as AssessmentSessionProcessTypeId)
          .then((res: AxiosResponse<ExamTaskGroupSolutionStatus>) => setExamTaskGroupSolutionStatus(res.data))
          .catch((e: AxiosResponse) => console.log({ e }));
      }
    }
  }, [cardId, processTypeId, props.mode, cardAbsoluteId]);

  const clearImageZones = () => {
    setImageZones([]);
  };

  const prepareImageZones = (zones: imageZone[], criterionNumber: string, orgzId: string) => {
    if (zones.length) {
      const newImageZones: SolutionImageZoneWithImgData[] = [];
      zones.forEach((zone: imageZone) => {
        const page = examSheetPages.current.find(
          (page: SolutionExamSheetPage) => page.pageNumber === zone.pageNumber.toString(),
        );
        if (page) {
          const newZone = {
            orgzId: orgzId,
            criterionNumber,
            zone,
            wholeImageData: page.imgData,
          };
          newImageZones.push(newZone);
        }
      });
      setImageZones(newImageZones.sort((a, b) => a.zone.orderNumber - b.zone.orderNumber));
      setImageZonesLoaded(true);
    } else {
      clearImageZones();
    }
  };

  useEffect(() => {
    setImageZonesLoaded(false);
  }, [activeCriterion?.examScoringSchemaId]);

  const getExamScoringSchemaImageZoneForCriterionInCardPreview = useCallback(
    _.debounce((activeCriterion: ExamScoringSchema, activeTask: ExamTask) => {
      getExamScoringSchemaImageZone(activeCriterion.examScoringSchemaId).then(
        (response: AxiosResponse<imageZone[]>) => {
          if (response.data.length) {
            setCurrentPage(response.data[0].pageNumber);
          } else {
            getTaskImageZones(activeTask.taskId).then(
              (response: AxiosResponse<imageZone[]>) => {
                setCurrentPage(response.data[0].pageNumber);
              },
              (error: AxiosError) => {
                clearImageZones();
                console.error(error);
              },
            );
            if (response.data.length === 0) {
              clearImageZones();
              getPages(activeTask);
            }
          }
        },
        (error: AxiosError) => {
          clearImageZones();
          console.error(error);
        },
      );
    }, 500),
    [],
  );

  const getExamScoringSchemaImageZoneForCriterionInSolutionPreview = useCallback(
    _.debounce((activeCriterion: ExamScoringSchema, activeTask: ExamTask, orgzId: string) => {
      getExamScoringSchemaImageZone(activeCriterion.examScoringSchemaId).then(
        (response: AxiosResponse<imageZone[]>) => {
          if (response.data.length) {
            prepareImageZones(response.data, activeCriterion.criterionNumber, orgzId);
          } else {
            getTaskImageZones(activeTask.taskId).then(
              (response: AxiosResponse<imageZone[]>) => {
                if (response.data.length === 0) {
                  clearImageZones();
                  getPages(activeTask);
                } else {
                  prepareImageZones(response.data, activeCriterion.criterionNumber, orgzId);
                }
              },
              (error: AxiosError) => {
                clearImageZones();
                console.error(error);
              },
            );
          }
        },
        (error: AxiosError) => {
          clearImageZones();
          console.error(error);
        },
      );
    }, 500),
    [],
  );

  const getExamScoringSchemaImageZoneForTaskInCardPreview = useCallback(
    _.debounce((activeTask: ExamTask) => {
      getTaskImageZones(activeTask.taskId).then(
        (response: AxiosResponse<imageZone[]>) => {
          if (response.data.length) {
            setCurrentPage(response.data[0].pageNumber);
            setImageZonesLoaded(true);
          } else {
            clearImageZones();
            getPages(activeTask);
          }
        },
        (error: AxiosError) => {
          clearImageZones();
          getPages(activeTask);
          console.error(error);
        },
      );
    }, 500),
    [],
  );

  const getExamScoringSchemaImageZoneForTaskInSolutionPreview = useCallback(
    _.debounce((activeTask: ExamTask, orgzId: string) => {
      getTaskImageZones(activeTask.taskId).then(
        (response: AxiosResponse<imageZone[]>) => {
          if (response.data.length) {
            prepareImageZones(response.data, activeTask.taskId, orgzId);
          } else {
            clearImageZones();
            getPages(activeTask);
          }
        },
        (error: AxiosError) => console.error(error),
      );
    }, 500),
    [],
  );

  useEffect(() => {
    if (
      !examSheetPagesLoaded ||
      (activeTask &&
        activeCriterion &&
        !activeTask.examScoringSchemas.find(
          (item) => item.examScoringSchemaId === activeCriterion?.examScoringSchemaId,
        ))
    ) {
      return;
    }

    if (
      previewType === 'card' &&
      activeTask &&
      !activeCriterion?.partialScoreId &&
      !activeCriterion?.examScoringSchemaId
    ) {
      getExamScoringSchemaImageZoneForTaskInCardPreview(activeTask);
    }

    if (
      previewType === 'card' &&
      activeTask &&
      (activeCriterion?.partialScoreId || activeCriterion?.examScoringSchemaId)
    ) {
      getExamScoringSchemaImageZoneForCriterionInCardPreview(activeCriterion, activeTask);
    }

    if (
      previewType === 'solution' &&
      activeTask &&
      (activeCriterion?.partialScoreId || activeCriterion?.examScoringSchemaId)
    ) {
      if (
        !(
          imageZones.length &&
          imageZones[0]?.zone?.id &&
          orgzId === imageZones[0].orgzId &&
          imageZones[0]?.criterionNumber === activeCriterion.criterionNumber
        )
      ) {
        getExamScoringSchemaImageZoneForCriterionInSolutionPreview(activeCriterion, activeTask, orgzId ?? '');
      }
    }
    if (
      previewType === 'solution' &&
      activeTask &&
      !activeCriterion?.partialScoreId &&
      !activeCriterion?.examScoringSchemaId
    ) {
      getExamScoringSchemaImageZoneForTaskInSolutionPreview(activeTask, orgzId ?? '');
    }
  }, [
    previewType,
    activeTask?.taskId,
    activeCriterion?.partialScoreId,
    activeCriterion?.examScoringSchemaId,
    props.mode,
    examSheetPagesLoaded,
    getExamScoringSchemaImageZoneForCriterionInCardPreview,
    getExamScoringSchemaImageZoneForCriterionInSolutionPreview,
    getExamScoringSchemaImageZoneForTaskInCardPreview,
    getExamScoringSchemaImageZoneForTaskInSolutionPreview,
  ]);

  const getExamSheet = async (url: string): Promise<AxiosResponse<ArrayBuffer>> => {
    const response = await axios.get(url, {
      responseType: 'arraybuffer',
    });
    return response;
  };

  useEffect(() => {
    if (!pagesUrls.length) {
      setExamSheetPagesLoaded(false);
    }
  }, [pagesUrls]);

  useEffect(() => {
    if (!pagesUrls.length) {
      return;
    }
    examSheetPages.current = [];
    examSheetPagesBuffer.current = [];
    pagesUrls.forEach((url, index) => {
      getExamSheet(url).then((response: AxiosResponse<ArrayBuffer>) => {
        const imgData = new Blob([response.data]);
        const pageNumber = `${index + 1}`;
        const foundPage = examSheetPagesBuffer.current.find((item) => item.pageNumber === pageNumber);
        if (!foundPage) {
          examSheetPagesBuffer.current = [
            ...examSheetPagesBuffer.current,
            {
              pageNumber,
              imgData,
            },
          ].sort((a, b) => parseInt(a.pageNumber) - parseInt(b.pageNumber));
        }
        if (pagesUrls.length > 0 && examSheetPagesBuffer.current.length === pagesUrls.length) {
          examSheetPages.current = examSheetPagesBuffer.current;
          setExamSheetPagesLoaded(true);
        }
      });
    });
  }, [pagesUrls]);

  const handleNavigationClick = useCallback(
    (next: boolean) => {
      const navigationId = next ? examTaskGroupSolutionsNavigation.nextId : examTaskGroupSolutionsNavigation.prevId;
      setExamSheetPagesLoaded(false);
      examSheetPages.current = [];
      if (navigationId) {
        resetPages();
        switch (props.mode) {
          case SolutionViewMode.assessment:
            setIsSidebarVisible(true);
            history.push(getSolutionUrl(navigationId, examinerId, processTypeId, deskId, examinerFunction));
            break;

          case SolutionViewMode.assessmentSampleAssessmentGroup:
            const orgzIdToNavigate = examTaskGroupSolutionsList.find((element) => element.id === navigationId);
            setIsSidebarVisible(true);
            history.push(
              getAssessmentSampleAssessmentGroupSolutionUrl(
                props.schoolId,
                navigationId,
                orgzIdToNavigate?.examTaskGroupSolutionScoreId,
                examinerId,
                examinerFunction,
              ),
            );
            break;

          case SolutionViewMode.sampleAssessmentGroupAssignment:
            setIsSidebarVisible(false);
            history.push(getSampleAssessmentGroupSolutionAssignmentUrl(props.schoolId, navigationId, examinerId));
            break;
        }
      }
    },
    [
      examTaskGroupSolutionsNavigation,
      resetPages,
      deskId,
      examTaskGroupSolutionsList,
      examinerFunction,
      examinerId,
      processTypeId,
      props.mode,
      props.schoolId,
    ],
  );

  const isSpecialCaseDisabled =
    (examTaskGroupSolutionWithTasks &&
      examTaskGroupSolutionWithTasks.examTaskGroupSolutionScoreState &&
      [Status.Assessed, Status.Closed].includes(examTaskGroupSolutionWithTasks?.examTaskGroupSolutionScoreState)) ||
    userFunction !== ExaminerFunction.CZE;

  const navRgzId = `ID_${props.mode === SolutionViewMode.sampleAssessmentGroupAssignment ? props.rgzId : orgzId}`;

  useEffect(() => {
    if (examinerId && userFunction !== undefined && userFunction === ExaminerFunction.CZE) {
      isExaminerBlocked === false &&
        isExaminerBlockedInSession().then((result: boolean) => setIsExaminerBlocked(result));
    }
  }, [examinerId, userFunction, isExaminerBlocked]);

  const handleClickCloseIcon = () => {
    history.push(getSampleAssessmentRepositoryUrl(props.schoolId));
  };

  const canUserMakeChangesToZWOProcess = (): boolean => {
    if (sampleExamTaskGroupSolutionScoreState === null) {
      return false;
    } else if (props.mode === SolutionViewMode.assessmentSampleAssessmentGroup) {
      switch (assessmentSession.examinerFunction) {
        case ExaminerFunction.CZWO:
          return sampleExamTaskGroupSolutionScoreState < SampleExamTaskGroupSolutionScoreState.DuringChairmanAcceptance;
        case ExaminerFunction.PZWO:
          return (
            sampleExamTaskGroupSolutionScoreState === SampleExamTaskGroupSolutionScoreState.DuringChairmanAcceptance
          );
        case ExaminerFunction.KK:
          return sampleExamTaskGroupSolutionScoreState === SampleExamTaskGroupSolutionScoreState.ChairmanAccepted;
        default:
          return false;
      }
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (activeAnnotationId !== '') {
      setAnnotationsVisible(true);
    }
  }, [activeAnnotationId]);

  const getHomeUrl = useCallback(() => {
    if (props.mode === SolutionViewMode.sampleAssessmentGroupAssignment) {
      return getSampleAssessmentRepositoryUrl();
    } else if (props.mode === SolutionViewMode.assessmentSampleAssessmentGroup) {
      const sessionId = assessmentSessionId ? assessmentSessionId : assessmentSession?.assessmentSessionId;
      return getSampleAssessmentUrl(sessionId, examinerId);
    } else {
      return undefined;
    }
  }, [props.mode, assessmentSessionId, processTypeId, examinerId]);

  const getAssessmentHomeUrl: () => string | false | undefined = useCallback(() => {
    const sessionId = assessmentSessionId || assessmentSession?.assessmentSessionId;

    if (props.mode === SolutionViewMode.assessment && sessionId && processTypeId) {
      showLoader(true);
      redirectionToProcess(
        sessionId,
        examinerId,
        processTypeId as unknown as AssessmentSessionProcessTypeId,
        isTrainingSession,
      ).then((data: { url: string }) => {
        if (data && data.url) {
          showLoader(false);
          history.push(data.url);
        }
      });
      return false;
    } else if (props.mode === SolutionViewMode.assessmentSampleAssessmentGroup && sessionId && examinerId) {
      return getSampleAssessmentUrl(sessionId, examinerId);
    } else if (props.mode === SolutionViewMode.sampleAssessmentGroupAssignment && props.schoolId) {
      return getSampleAssessmentRepositoryUrl(props.schoolId);
    } else return '/';
  }, [props.mode, assessmentSessionId, processTypeId, examinerId, isTrainingSession]);

  const checkIfIsTrainingSession = () => {
    getIsTraingSession().then((res) => {
      setIsTrainingSession(res.data);
    });
  };

  useEffect(() => {
    checkIfIsTrainingSession();
  }, []);

  useEffect(() => {
    if (props.mode === SolutionViewMode.sampleAssessmentGroupAssignment) return;
    getAnnotationDefinitions().then((annotationDefinitions: AnnotationDefinition[]) => {
      setAnnotationDefinitions(annotationDefinitions);
    });
  }, [props.mode]);

  const refreshAnnotationCriterion = useCallback(
    _.debounce((id: string) => {
      if (orgzId !== undefined) {
        getCriterionAnnotation(id, orgzId).then(
          (response: AxiosResponse<AnnotationsCriterionDTO>) => {
            const data = response.data;
            setAnnotationsCriterion(data.annotationDtos !== null ? data.annotationDtos : []);
            setIsSorted(data.isSorted);
          },
          () => {
            console.error();
          },
        );
      }
    }, 500),
    [orgzId],
  );

  const handleSendbackOrConfirmCompleted = () => {
    if (props.mode === SolutionViewMode.assessmentSampleAssessmentGroup) {
      refreshSampleExamTaskGroupSolutionScoreState(orgzId);
    }
    if (examTaskGroupSolutionScoreVersionId && orgzId) {
      setExamTaskGroupSolutionScoreVersionId(undefined);
      refreshComments(orgzId);
      refreshAnnotations(orgzId);
      refreshExamTasks();
    }
  };

  const handleAnnotationsOpen = () => {
    setIsAnnotationsOpen(!isAnnotationsOpen);
  };

  useEffect(() => {
    if (activeCriterion) {
      setIsAnnotationsOpen(true);
    }
  }, [activeCriterion]);

  useEffect(() => {
    activeCriterion && refreshAnnotationCriterion(activeCriterion.examScoringSchemaId);
  }, [activeCriterion, isAnnotationsOpen, refreshAnnotationCriterion]);

  const handleSaveComment = (): Promise<unknown> => {
    return new Promise((resolve, reject) => {
      if (orgzId) {
        showLoader(true);
        getComments(orgzId, examTaskGroupSolutionScoreVersionId)
          .then(
            (response: AxiosResponse<IComment[]>) => {
              const data = response.data;
              setComments(data);
              resolve(undefined);
            },
            () => {
              console.error();
              reject();
            },
          )
          .finally(() => {
            showLoader(false);
          });
      }
    });
  };

  useEffect(() => {
    if (isForcedCommentChanged && examTaskGroupSolutionScoreVersionId) {
      if (orgzId && examTaskGroupSolutionScoreVersionId) {
        showLoader(true);
        getComments(orgzId, examTaskGroupSolutionScoreVersionId)
          .then(
            (response: AxiosResponse<IComment[]>) => {
              const data = response.data;
              setComments(data);
              setIsForcedCommentChanged(false);
            },
            () => {
              console.error();
            },
          )
          .finally(() => {
            setIsCommentUpdate(false);
            showLoader(false);
          });
      }
    }
  }, [isForcedCommentChanged, examTaskGroupSolutionScoreVersionId]);

  const canUserAssess =
    assessmentSession.assessmentSessionStateId !== AssessmentSessionState.Closed &&
    !isReadOnly &&
    examTaskGroupSolutionStatus !== ExamTaskGroupSolutionStatus.NoneSessionClosed;

  const processTypeIdInt: AssessmentSessionProcessTypeId | undefined =
    processTypeId !== undefined ? (parseInt(processTypeId) as AssessmentSessionProcessTypeId) : undefined;

  const checkIfUserCanEditScore = useCallback(() => {
    if (assessmentSession.assessmentSessionStateId === AssessmentSessionState.Closed) return false;
    if (!canUserAssess && userFunction !== ExaminerFunction.KK) return false;
    if (props.mode === SolutionViewMode.sampleAssessmentGroupAssignment) return false;
    if (userFunction === undefined) return true;
    if (userFunction !== undefined) {
      if (
        userFunction === ExaminerFunction.CZE &&
        examTaskGroupSolutionWithTasks &&
        examTaskGroupSolutionWithTasks.examTaskGroupSolutionScoreState !== Status.Closed
      ) {
        return true;
      }
      if (
        props.mode === SolutionViewMode.assessment &&
        examTaskGroupSolutionWithTasks &&
        examTaskGroupSolutionWithTasks.examTaskGroupSolutionScoreState === Status.Closed &&
        processTypeIdInt === AssessmentSessionProcessTypeId.Scoring &&
        [ExaminerFunction.KK, ExaminerFunction.KGZ].includes(userFunction)
      ) {
        return true;
      }
      if (canUserMakeChangesToZWOProcess()) return true;
      return false;
    } else return true;
  }, [
    props.mode,
    canUserMakeChangesToZWOProcess,
    canUserAssess,
    userFunction,
    examTaskGroupSolutionWithTasks?.examTaskGroupSolutionScoreState,
  ]);

  const sessionIsOpen =
    assessmentSession.assessmentSessionStateId === AssessmentSessionState.Opened ||
    assessmentSession.sampleAssessmentSessionStateId === SampleAssessmentSessionState.Open;
  const sessionIsNew =
    (assessmentSession.assessmentSessionStateId === AssessmentSessionState.New &&
      assessmentSession.sampleAssessmentSessionStateId !== SampleAssessmentSessionState.Closed) ||
    assessmentSession.sampleAssessmentSessionStateId === SampleAssessmentSessionState.Open;
  const PZWOFunction = userFunction === ExaminerFunction.PZWO;
  const CZWOFunction = userFunction === ExaminerFunction.CZWO;
  const CZEFunction = userFunction === ExaminerFunction.CZE;
  const PZEFunction = userFunction === ExaminerFunction.PZE;
  const KKFunction = userFunction === ExaminerFunction.KK;
  const KGZFunction = userFunction === ExaminerFunction.KGZ;

  const canAddCommentOnPage = canUserAssess && checkIfUserCanEditScore();
  const canAddCommentOutsidePage = canUserAssess;

  const canAddCommentOnCriterion =
    !!examTaskGroupSolutionWithTasks &&
    (((CZEFunction || CZWOFunction) &&
      examTaskGroupSolutionWithTasks.examTaskGroupSolutionScoreState !== Status.Closed) ||
      ((PZEFunction || KGZFunction || KKFunction || PZWOFunction) &&
        examTaskGroupSolutionWithTasks.examTaskGroupSolutionScoreState === Status.Closed));

  const canEditComment =
    (sessionIsNew && (CZWOFunction || PZWOFunction)) || (sessionIsOpen && (!PZWOFunction || !CZWOFunction));

  const commentsOnPage = useMemo(() => {
    return comments ? comments.filter((comment: IComment) => comment.commentTypeId === CommentTypeId.ONIMAGE) : [];
  }, [comments]);
  const canAddAnnotation =
    (CZEFunction &&
      processTypeIdInt !== undefined &&
      [
        AssessmentSessionProcessTypeId.Training,
        AssessmentSessionProcessTypeId.Qualification,
        AssessmentSessionProcessTypeId.Scoring,
      ].includes(processTypeIdInt) &&
      examTaskGroupSolutionWithTasks?.examTaskGroupSolutionScoreState !== Status.Closed) ||
    (CZWOFunction &&
      sampleExamTaskGroupSolutionScoreState !== null &&
      [
        SampleExamTaskGroupSolutionScoreState.NotAssessed,
        SampleExamTaskGroupSolutionScoreState.DuringAssessment,
      ].includes(sampleExamTaskGroupSolutionScoreState)) ||
    (PZWOFunction &&
      sampleExamTaskGroupSolutionScoreState !== null &&
      sampleExamTaskGroupSolutionScoreState === SampleExamTaskGroupSolutionScoreState.DuringChairmanAcceptance) ||
    ((KKFunction || KGZFunction) &&
      examTaskGroupSolutionWithTasks?.examTaskGroupSolutionScoreState === Status.Closed &&
      processTypeIdInt === AssessmentSessionProcessTypeId.Scoring) ||
    (KKFunction && sampleExamTaskGroupSolutionScoreState === SampleExamTaskGroupSolutionScoreState.ChairmanAccepted);

  const canEditRemoveAnnotation =
    checkIfUserCanEditScore() ||
    ((KKFunction || KGZFunction) &&
      examTaskGroupSolutionWithTasks?.examTaskGroupSolutionScoreState === Status.Closed) ||
    (KKFunction && sampleExamTaskGroupSolutionScoreState === SampleExamTaskGroupSolutionScoreState.ChairmanAccepted) ||
    (PZWOFunction &&
      sampleExamTaskGroupSolutionScoreState === SampleExamTaskGroupSolutionScoreState.DuringChairmanAcceptance);

  const isAnnotationToolOpen = activeCriterion !== null && annotationsCriterion?.length !== 0 && isAnnotationsOpen;

  const isAnnotationForGrading = (annotationDefinitionId: string): boolean => {
    if (!annotationsCriterion) {
      return false;
    }
    return !!annotationsCriterion.find(
      (item: AnnotationSequence) => item.annotationDefinitionId === annotationDefinitionId && item.gradingAnnotation,
    );
  };

  const anyAnnotationForGradingProvided: boolean = useMemo(() => {
    if (!annotationsCriterion) {
      return false;
    }
    return !!annotationsCriterion.find((item: AnnotationSequence) => item.gradingAnnotation);
  }, [annotationsCriterion]);

  const hasPermissionExaminerCommunicationAccess = usePermission(UserPermission.ExaminerCommunicationAccess);

  const isSendMessageToOrgzVisible =
    props.mode === SolutionViewMode.assessment &&
    examTaskGroupSolutionWithTasks &&
    examTaskGroupSolutionWithTasks.examTaskGroupSolutionScoreState === Status.Assessed &&
    (KKFunction || PZEFunction || KGZFunction) &&
    hasPermissionExaminerCommunicationAccess;

  useEffect(() => {
    setRotateAngle(0);
  }, [activeTask]);

  const removeAnnotations = (conditionToRemove: (item: AnnotationOnImage) => boolean) => {
    setAnnotations((prevState) => {
      const result = prevState ? prevState.filter((item) => !conditionToRemove(item)) : prevState;
      return result;
    });
  };

  const removeAllGradingAnnotationsForActiveTask = () => {
    if (!activeTask) return;
    removeAnnotations((item: AnnotationOnImage) => {
      return (
        item.forScoring &&
        activeTask.examScoringSchemas.map((schema) => schema.examScoringSchemaId).includes(item.examScoringSchemaId)
      );
    });
  };

  const gradingAnnotationAddedToCriterion = annotations?.filter(
    (item) => item.forScoring && activeCriterion && activeCriterion.examScoringSchemaId === item.examScoringSchemaId,
  );

  const removeAllGradingAnnotationsForCriterion = (criterion: ExamScoringSchema) => {
    removeAnnotations((item: AnnotationOnImage) => {
      return item.forScoring && criterion.examScoringSchemaId === item.examScoringSchemaId;
    });
  };

  const removeAllRequiredCommentsForCriterion = (prevScore: number, criterion: ExamScoringSchema) => {
    if (isCommentForScoreRequired(prevScore, criterion)) {
      setComments((prevState) =>
        !prevState ? prevState : prevState.filter((item) => item.partialScoreId !== criterion.partialScoreId),
      );
    }
  };

  const collectScoresRequiringCurrentUserCommentForCriterion = (newScore: number, criterion: ExamScoringSchema) => {
    if (isCommentForScoreRequired(newScore, criterion)) {
      setScoresRequiringCurrentUserComment((prevState) => [
        ...prevState,
        { partialScoreId: criterion.partialScoreId, score: newScore },
      ]);
    }
  };

  const collectScoresRequiringCurrentUserCommentForActiveCriterion = (newScore: number) => {
    if (!activeCriterion) return;
    collectScoresRequiringCurrentUserCommentForCriterion(newScore, activeCriterion);
  };

  const findAndResetDependentCriterions = (criterion: ExamScoringSchema, newScore: number | null) => {
    const setupsForcingDependentCriterionReset = getSetupsForcingDependentCriterionReset(criterion, newScore);
    if (setupsForcingDependentCriterionReset.length) {
      setupsForcingDependentCriterionReset.forEach((setup) => {
        const dependentCriterion = getCriterionFromActiveTask(setup.dependentSchemaId);
        if (dependentCriterion && dependentCriterion.score !== null) {
          removeAllGradingAnnotationsForCriterion(dependentCriterion);

          if (examTaskGroupSolutionWithTasks?.examTaskGroupSolutionScoreState === Status.Open) {
            removeAllRequiredCommentsForCriterion(dependentCriterion.score, dependentCriterion);
          }

          if (
            newScore !== null &&
            examTaskGroupSolutionWithTasks &&
            examTaskGroupSolutionWithTasks.examTaskGroupSolutionScoreState !== null &&
            userFunction !== undefined &&
            [ExaminerFunction.KK, ExaminerFunction.KGZ].includes(userFunction) &&
            examTaskGroupSolutionWithTasks.examTaskGroupSolutionScoreState === Status.Closed &&
            examTaskGroupSolutionWithTasks.assessmentQuality !== null // RGZ is not control RGZ
          ) {
            collectScoresRequiringCurrentUserCommentForCriterion(newScore, dependentCriterion);
          }
          updateScoreInCriterion(null, dependentCriterion);
          findAndResetDependentCriterions(dependentCriterion, null);
        }
      });
    }
  };

  const handleDeleteTaskScore = useCallback(() => {
    removeAllGradingAnnotationsForActiveTask();
    if (orgzId !== undefined) {
      if (!currentCommentsOutsidePage.length) {
        refreshComments(orgzId, examTaskGroupSolutionScoreVersionId);
      }
    }
  }, [examTaskGroupSolutionScoreVersionId, orgzId, annotations, activeCriterion, activeTask]);

  const handleUpdateScore = useCallback(
    (newScore: number | null, prevScore: number | null, criterion: ExamScoringSchema) => {
      if (newScore === 0) {
        removeAllGradingAnnotationsForCriterion(criterion);
      }

      if (
        newScore !== null &&
        userFunction !== undefined &&
        examTaskGroupSolutionWithTasks &&
        examTaskGroupSolutionWithTasks.examTaskGroupSolutionScoreState !== null &&
        canUserAssessAfterSendingBack(
          userFunction,
          examTaskGroupSolutionWithTasks.examTaskGroupSolutionScoreState,
          examTaskGroupSolutionWithTasks.assessmentQuality !== null,
        )
      ) {
        collectScoresRequiringCurrentUserCommentForActiveCriterion(newScore);
      }

      if (activeCriterion) {
        findAndResetDependentCriterions(activeCriterion, newScore);
      }
    },
    [
      userFunction,
      examTaskGroupSolutionWithTasks,
      examTaskGroupSolutionScoreVersionId,
      orgzId,
      annotations,
      activeCriterion,
      activeTask,
    ],
  );

  useEffect(() => {
    onBeforeScoreStore((criterion: ExamScoringSchema | null, task: ExamTask | null) => {
      return new Promise<ExamTaskGroupSolutionScoreShelfResponse | undefined>((resolve, reject) => {
        if (
          orgzId &&
          props.mode === SolutionViewMode.assessment &&
          userFunction !== undefined &&
          examTaskGroupSolutionWithTasks &&
          examTaskGroupSolutionWithTasks.examTaskGroupSolutionScoreState !== null &&
          canUserAssessAfterSendingBack(
            userFunction,
            examTaskGroupSolutionWithTasks.examTaskGroupSolutionScoreState,
            examTaskGroupSolutionWithTasks.assessmentQuality !== null,
          ) &&
          !examTaskGroupSolutionScoreVersionId
        ) {
          showLoader(true, 'Aktualizacja oceny');
          setIsCommentUpdate(true);
          createExamTaskGroupSolutionScoreShelf(orgzId)
            .then(
              (response: AxiosResponse<ExamTaskGroupSolutionScoreShelfResponse>) => {
                setExamTaskGroupSolutionScoreVersionId(response.data.examTaskGroupSolutionScoreVersionId);
                setAnnotations(response.data.annotationsDto.dtos);
                loadTasks(response.data.examTasksCriteriaDto);

                let newActiveCriterion = null;
                let newActiveTask = null;
                if (criterion) {
                  newActiveCriterion = getCriterionFromTasks(
                    response.data.examTasksCriteriaDto.examTasksCriteria,
                    criterion.examScoringSchemaId,
                  );

                  if (!newActiveCriterion) {
                    openAlert('save_error');
                    reject();
                  } else {
                    activateCriterion(newActiveCriterion);
                  }
                }

                if (task) {
                  newActiveTask = getTaskFromTasks(response.data.examTasksCriteriaDto.examTasksCriteria, task.taskId);

                  if (!newActiveTask) {
                    openAlert('save_error');
                    reject();
                  }
                  setActiveTask(newActiveTask);
                }
                resolve(response.data);
              },
              () => {
                reject();
              },
            )
            .finally(() => {
              setIsCommentUpdate(false);
            });
        } else {
          resolve(undefined);
        }
      });
    });

    onUpdateScore((newScore: number | null, prevScore: number | null, criterion: ExamScoringSchema) => {
      handleUpdateScore(newScore, prevScore, criterion);
    });

    onDeleteTaskScore(() => {
      handleDeleteTaskScore();
    });
  }, [
    annotations,
    activeCriterion,
    activeTask,
    orgzId,
    props.mode,
    examTaskGroupSolutionWithTasks,
    examTaskGroupSolutionWithTasks?.examTaskGroupSolutionScoreState,
  ]);

  const isCommentOnCriterion = () => {
    return (
      activeCriterion?.score !== null &&
      !activeTask?.noAnswer &&
      activeCriterion?.examScoreValues.some((e) => e.score === activeCriterion.score && e.isCommentRequired)
    );
  };

  const isCommentOnCriterionAdded = () => {
    return !!currentCommentsOutsidePage.some(
      (e) => e.commentTypeId === CommentTypeId.ONCRITERIA && e.partialScoreId === activeCriterion?.partialScoreId,
    );
  };

  const getCommentForScoreInCriterion = (criterionPartialScoreId: string, score: number): IComment | undefined => {
    if (isForcedCommentChanged || isCommentUpdate) return;
    if (comments) {
      const shouldCurrentUserAddCommentForScore = !!scoresRequiringCurrentUserComment.find(
        (item) => item.partialScoreId === criterionPartialScoreId && item.score === score,
      );

      return comments.find(
        (comment) =>
          comment.commentTypeId === CommentTypeId.ONCRITERIA &&
          comment.partialScoreId === criterionPartialScoreId &&
          comment.criterionPoints === score &&
          (!shouldCurrentUserAddCommentForScore || comment.examinerId === user.profile.sub),
      );
    } else {
      return undefined;
    }
  };

  useEffect(() => {
    if (activeCriterion && activeScore !== null) {
      updateIsCommentForCurrentScoreProvided(
        !!getCommentForScoreInCriterion(activeCriterion.partialScoreId, activeScore),
      );
    }
  }, [activeCriterion, activeScore, comments, scoresRequiringCurrentUserComment]);

  useEffect(() => {
    if (activeTask?.noAnswer && orgzId && !isCommentUpdate) {
      refreshComments(orgzId, examTaskGroupSolutionScoreVersionId);
    }
  }, [activeTask?.noAnswer, orgzId, examTaskGroupSolutionScoreVersionId, isCommentUpdate]);

  useEffect(() => {
    if (!comments) {
      return comments;
    }
    if (isForcedCommentChanged || isCommentUpdate) return;

    const currentComments = comments.filter(
      (comment) =>
        comment.commentTypeId === CommentTypeId.OFFPAGE ||
        (comment.commentTypeId === CommentTypeId.ONCRITERIA &&
          activeCriterion &&
          comment.partialScoreId === activeCriterion.partialScoreId),
    );
    setCurrentCommentsOutsidePage(currentComments);
  }, [comments, activeCriterion, isCommentUpdate, examTaskGroupSolutionScoreVersionId, isForcedCommentChanged]);

  useEffect(() => {
    const shortcutsListener = (event: KeyboardEvent) => {
      if (!isAnyModalOpened && !isAnnotationSelected) {
        if (event.ctrlKey && event.shiftKey && event.key === 'F' && !isFullscreen) {
          setIsFullscreen(true);
          setIsSidebarVisible(false);
        }
        if (event.key === 'f' && isFullscreen) {
          setIsFullscreen(false);
          setIsSidebarVisible(true);
        }
        if (event.ctrlKey && event.key === 'ArrowRight') {
          handleNavigationClick(true);
        }
        if (event.ctrlKey && event.key === 'ArrowLeft') {
          handleNavigationClick(false);
        }
      }
    };
    document.addEventListener('keydown', shortcutsListener);
    return () => {
      document.removeEventListener('keydown', shortcutsListener);
    };
  }, [isFullscreen, examTaskGroupSolutionsNavigation, isAnyModalOpened, isAnnotationSelected]);

  const dispatch = useDispatch();

  const isContextualHelp = useSelector((state: RootState) => state.contextualHelp.isContextualHelp);

  const [activatedContextualHelp, setActivatedContextualHelp] = useState<number | undefined>();
  const navigationBar =
    props.mode === SolutionViewMode.assessmentSampleAssessmentGroup
      ? 12
      : props.mode === SolutionViewMode.assessment
      ? 1
      : 9;
  const commentsBar = props.mode === SolutionViewMode.assessmentSampleAssessmentGroup ? 13 : 2;
  const toolsBar = props.mode === SolutionViewMode.assessmentSampleAssessmentGroup ? 14 : 3;
  const scoringBar = props.mode === SolutionViewMode.assessmentSampleAssessmentGroup ? 15 : 4;
  const scoringToolsBar = props.mode === SolutionViewMode.assessmentSampleAssessmentGroup ? 16 : 5;
  const tasksListBar = props.mode === SolutionViewMode.assessmentSampleAssessmentGroup ? 18 : 17;

  useEffect(() => {
    dispatch(contextualHelpActions.toogleContextualHelp(false));
  }, []);

  useEffect(() => {
    adjustLayout_dangerously(props.mode, navigationBar);
  }, [isContextualHelp, isSidebarVisible]);

  SignalRContext.useSignalREffect(
    CallbackMethodNames.ExaminerUnblocked,
    (message) => {
      if (message.assessmentSessionId === assessmentSessionId) {
        setIsExaminerBlocked(false);
        setExamTaskGroupSolutionStatus(ExamTaskGroupSolutionStatus.Available);
      }
    },
    [],
  );

  return (
    <>
      <div style={{ overflowY: isFullscreen ? 'hidden' : 'visible' }}>
        {!isFullscreen && (
          <>
            <SkipLink isSkipLink={isSkipLink} setIsSkipLink={setIsSkipLink} />
            <Navbar
              getHomeUrl={getHomeUrl}
              getAssessmentHomeUrl={getAssessmentHomeUrl}
              examinerView={true}
              messageModalIsOpen={setIsSpecialCaseModalOpen}
              isSkipLink={isSkipLink}
            />
          </>
        )}
        <SnackbarDownload
          open={isSnackbarVisible}
          onClose={() => setIsSnackbarVisible(false)}
          autoHideDuration={4000}
          text={snackbarMessage}
        />
        <div
          id="main-content"
          className={!isFullscreen ? classes.container : [classes.container, classes.containerFullscreen].join(' ')}
          style={examTaskSolutionsTabsMode ? { justifyContent: 'flex-start' } : undefined}
        >
          {props.mode === SolutionViewMode.sampleAssessmentGroupAssignment && (
            <CloseIcon onClick={handleClickCloseIcon} style={{ position: 'absolute', top: 2, right: 20 }} />
          )}
          {props.tabs &&
            props.tabs.length > 0 &&
            props.activeTabIndex !== undefined &&
            props.onChangeTab &&
            props.tabIndexesWithUnsavedShelf && (
              <TabsBar
                isFullscreen={isFullscreen}
                activeTabIndex={props.activeTabIndex}
                isShelfAssessing={isShelfAssessing}
                tabs={props.tabs}
                onChangeTab={props.onChangeTab}
                tabIndexesWithUnsavedShelf={props.tabIndexesWithUnsavedShelf}
                tabHeight={TAB_HEIGHT}
              />
            )}
          <div
            className={!isFullscreen ? classes.mainContainer : classes.mainContainerFullScreen}
            style={{
              margin: examTaskSolutionsTabsMode ? '0px' : undefined,
              height:
                examTaskSolutionsTabsMode && !isFullscreen ? `calc(100% - 52px - ${TAB_HEIGHT / 2}px)` : undefined,
              outline: 'none',
            }}
          >
            <div
              id="navigationBar"
              style={{
                width: !isSidebarVisible ? 'calc(100% - 1px)' : 'calc(80% - 1px)',
                height: '100%',
                overflow: 'hidden',
              }}
            >
              <Menu isFullscreen={isFullscreen} isSidebarVisible={isSidebarVisible}>
                {isContextualHelp && (
                  <div
                    style={{
                      position: 'relative',
                      left: props.mode === SolutionViewMode.sampleAssessmentGroupAssignment ? '490px' : '50px',
                    }}
                  >
                    <ContextualHelp
                      id={navigationBar}
                      isActive={activatedContextualHelp === navigationBar}
                      onClick={setActivatedContextualHelp}
                      placement={'right'}
                    />
                  </div>
                )}
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    alignItems: 'center',
                    paddingTop: !isFullscreen ? '2px' : '15px',
                    marginTop: '-5px',
                  }}
                >
                  {!isFullscreen ? (
                    <>
                      {props.mode === SolutionViewMode.sampleAssessmentGroupAssignment && (
                        <Typography className={classes.schoolCode}>{schooldCode}</Typography>
                      )}
                      {props.mode === SolutionViewMode.assessment && examTaskGroupSolutionWithTasks && (
                        <ChipButton value={examTaskGroupSolutionWithTasks.examTaskGroupSolutionScoreState} />
                      )}
                      <Nav
                        isFullscreen={isFullscreen}
                        rgzId={navRgzId}
                        examinerName={examinerName}
                        handlePrevClick={() => handleNavigationClick(false)}
                        handleNextClick={() => handleNavigationClick(true)}
                        prevDisabled={examTaskGroupSolutionsNavigation.prevId === null}
                        nextDisabled={examTaskGroupSolutionsNavigation.nextId === null}
                        examinerFunction={userFunction}
                        navigationType={viewType}
                        withoutNavigation={examTaskSolutionsTabsMode}
                      />
                      <>
                        <img src={vl} alt="linia pionowa" />
                        <SwitchView
                          handleSwitchView={handleSwitchView}
                          isCardPreview={previewType === 'card'}
                          isSolutionPreview={previewType === 'solution'}
                        />
                      </>
                      {userFunction === ExaminerFunction.CZE &&
                        props.mode === SolutionViewMode.assessment &&
                        examTaskGroupSolutionStatus !== undefined &&
                        examTaskGroupSolutionStatus !== ExamTaskGroupSolutionStatus.NoneSessionClosed &&
                        !examTaskSolutionsTabsMode && (
                          <>
                            <img src={vl} alt="linia pionowa" />
                            <CardsDownloaderContainer
                              processTypeId={parseInt(processTypeId)}
                              assessmentSessionId={assessmentSession.assessmentSessionId}
                              onDownloadFinish={handleDownloadFinish}
                              onRender={(onDownloadStart) => {
                                return (
                                  <Download
                                    status={examTaskGroupSolutionStatus}
                                    handleCardDownload={() => onDownloadStart(DownloadType.single)}
                                    handleCardGroupDownload={() => onDownloadStart(DownloadType.fillToLimits)}
                                  />
                                );
                              }}
                            ></CardsDownloaderContainer>
                          </>
                        )}
                      {props.mode === SolutionViewMode.assessment && (
                        <>
                          {examTaskGroupSolutionStatus !== ExamTaskGroupSolutionStatus.NoneSessionClosed &&
                            parseInt(processTypeId !== undefined ? processTypeId : '') ===
                              AssessmentSessionProcessTypeId.Scoring && (
                              <SpecialCaseIcons
                                rgzId={orgzId}
                                isSpecialCaseDisabled={isSpecialCaseDisabled}
                                cardId={cardId}
                                isSpecialCaseModalOpen={setIsSpecialCaseModalOpen}
                              />
                            )}
                        </>
                      )}
                      {props.mode === SolutionViewMode.assessment && (
                        <FlagsTableItem
                          flags={examTaskGroupSolutionWithTasks?.examTaskGroupSolutionScoreFlags ?? []}
                          examTaskGroupSolutionScoreId={orgzId}
                          allAvailableFlags={flags}
                          onSave={refreshExamTasks}
                          isSolutionView={true}
                          setIsAssignFlagsModalOpen={setIsAssignFlagsModalOpen}
                        />
                      )}

                      {isSendMessageToOrgzVisible && (
                        <>
                          <TooltipOne title={'Wyślij wiadomość powiązaną z RGZ'}>
                            <IconButton
                              disableRipple
                              onClick={() => setMessageModal({ open: true, type: 'orgzMessage' })}
                            >
                              <ForwardToInboxIcon />
                            </IconButton>
                          </TooltipOne>
                        </>
                      )}
                      {isExaminerBlockedPromptOpen && (
                        <ExaminerBlocked
                          isAssessmentsView={false}
                          onClose={() => setIsExaminerBlockedPromptOpen(false)}
                        />
                      )}
                      <div className={classes.pullRightContainer}>
                        <AssignToSampleAssessmentGroup
                          examTaskGroupSolutionId={props.rgzId}
                          isVisible={
                            props.mode === SolutionViewMode.sampleAssessmentGroupAssignment &&
                            assessmentSession.examinerFunction === ExaminerFunction.CZWO
                          }
                        />
                        {orgzId !== undefined && (
                          <ProcessQualification
                            id={orgzId}
                            isVisible={
                              props.mode === SolutionViewMode.assessmentSampleAssessmentGroup &&
                              [ExaminerFunction.CZWO, ExaminerFunction.PZWO, ExaminerFunction.KK].includes(
                                assessmentSession.examinerFunction,
                              )
                            }
                            isReadonly={
                              props.mode === SolutionViewMode.assessmentSampleAssessmentGroup &&
                              !canUserMakeChangesToZWOProcess()
                            }
                            examinerFunction={assessmentSession.examinerFunction}
                            onProcessSelect={setSampleAssessmentSelectedProcess}
                          />
                        )}
                        {(props.mode === SolutionViewMode.assessment ||
                          props.mode === SolutionViewMode.assessmentSampleAssessmentGroup) && (
                          <>{isScoringAdjusted && <AdjustmentsDefined />}</>
                        )}
                      </div>
                    </>
                  ) : (
                    <Nav
                      isFullscreen={isFullscreen}
                      rgzId={navRgzId}
                      examinerName={examinerName}
                      handlePrevClick={() => handleNavigationClick(false)}
                      handleNextClick={() => handleNavigationClick(true)}
                      prevDisabled={examTaskGroupSolutionsNavigation.prevId === null}
                      nextDisabled={examTaskGroupSolutionsNavigation.nextId === null}
                      examinerFunction={userFunction}
                      navigationType={viewType}
                    />
                  )}
                </div>
              </Menu>
              {props.mode !== SolutionViewMode.sampleAssessmentGroupAssignment && (
                <div id="commentsBar" className={classes.commentsContainer}>
                  {isContextualHelp && (
                    <div style={{ position: 'relative', left: '1030px', top: '-10px' }}>
                      <ContextualHelp
                        id={commentsBar}
                        isActive={activatedContextualHelp === commentsBar}
                        onClick={setActivatedContextualHelp}
                        placement={'left'}
                      />
                    </div>
                  )}
                  <CommentsOutsidePage
                    comments={currentCommentsOutsidePage}
                    handleClick={(comment: boolean) => setIsCommentsOpen(comment)}
                    rgzId={orgzId}
                    handleSave={handleSaveComment}
                    canAddComment={canAddCommentOutsidePage}
                    canAddCommentOnCriterion={canAddCommentOnCriterion}
                    canEditComment={canEditComment && (canAddAnnotation || !isCommentOnCriterion())}
                    isCommentOnCriterion={isCommentOnCriterion()}
                    isCommentOnCriterionAdded={isCommentOnCriterionAdded()}
                    checkIfUserCanEditScore={() =>
                      checkIfUserCanEditScore() && props.mode === SolutionViewMode.assessment
                    }
                  />
                </div>
              )}
              <div id="toolBar" style={{ display: 'flex', height: '100%', position: 'relative', overflow: 'hidden' }}>
                <SideToolbar
                  mode={props.mode}
                  previewType={previewType}
                  isFullscreen={isFullscreen}
                  isToolbarOpen={isToolbarOpen}
                  isThumbnailsOpen={isThumbnailsOpen}
                  handleToolbarOpen={handleToolbarOpen}
                  handleThumbnailsOpen={handleThumbnailsOpen}
                  handleAnnotationsOpen={handleAnnotationsOpen}
                  onCommentDragStateChange={(isDragging: boolean) => setIsNewCommentDragging(isDragging)}
                  canAddComment={canAddCommentOnPage}
                  isAnnotationToolOpen={activeCriterion !== null && annotationsCriterion?.length !== 0}
                />
                {props.mode !== SolutionViewMode.sampleAssessmentGroupAssignment && isContextualHelp && (
                  <div style={{ position: 'relative', left: '-43px', top: '180px' }}>
                    <ContextualHelp
                      id={toolsBar}
                      isActive={activatedContextualHelp === toolsBar}
                      onClick={setActivatedContextualHelp}
                      placement={'right'}
                    />
                  </div>
                )}
                <Toolbar
                  isOpen={isToolbarOpen}
                  isFullscreen={isFullscreen}
                  totalPages={totalPages}
                  zoomFactor={zoomFactor}
                  zoomValues={zoomFactorValues}
                  rotateAngle={rotateAngle}
                  currentPage={currentPage}
                  handleZoomChange={handleZoomChange}
                  handleZoomIn={handleZoomIn}
                  handleZoomOut={handleZoomOut}
                  handleRotateLeft={handleRotateLeft}
                  handleRotateRight={handleRotateRight}
                  setCurrentPage={setCurrentPage}
                  handleToolbarOpen={handleToolbarOpen}
                  handleViewMultiplePages={handleMultiplePagesView}
                  setRotateAngle={setRotateAngle}
                  pageActionsDisabled={previewType === 'solution'}
                  isAnnotationOpenAndDocked={isAnnotationDocked && isAnnotationToolOpen}
                />
                {props.mode !== SolutionViewMode.sampleAssessmentGroupAssignment && (
                  <AnnotationTool
                    isOpen={isAnnotationToolOpen}
                    handleAnnotationsOpen={handleAnnotationsOpen}
                    activeCriterion={activeCriterion}
                    activeAnnotationId={activeAnnotationId}
                    onActivateAnnotation={(id: string) => {
                      prevActiveAnnotationId.current = activeAnnotationId === '' ? id : activeAnnotationId;
                      setActiveAnnotationId(id);
                    }}
                    isAnnotationToolDocked={(value: boolean) => handleDocked(value)}
                    noAnswer={activeTask ? activeTask.noAnswer : null}
                    annotationsDefinition={annotationDefinitions}
                    annotationsCriterion={annotationsCriterion}
                    annotationOnPage={annotations}
                    isSorted={isSorted}
                    canSeeAnnotationTool={canAddAnnotation}
                    isFullscreen={isFullscreen}
                    isCommentOpen={isCommentsOpen}
                  />
                )}
                <Thumbnails
                  isOpen={isThumbnailsOpen && previewType === 'card'}
                  isFullscreen={isFullscreen}
                  totalPages={totalPages}
                  pagesUrls={pagesUrls}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  handleThumbnailsOpen={handleThumbnailsOpen}
                  setRotateAngle={setRotateAngle}
                  isAnnotationOpenAndDocked={isAnnotationDocked && isAnnotationToolOpen}
                />
                {examTaskGroupSolutionWithTasks && userFunction !== undefined && (
                  <Preview
                    mode={props.mode}
                    previewCardFullWidth={!isSidebarVisible}
                    pagesUrls={pagesUrls}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    zoomFactor={zoomFactor}
                    rotateAngle={rotateAngle}
                    viewSinglePage={viewSinglePage}
                    viewTwoPages={viewTwoPages}
                    isFullscreen={isFullscreen}
                    handleFullscreen={handleFullscreen}
                    examinerFunction={userFunction}
                    examTasksCoordinates={examTasksCoordinates}
                    orgzId={orgzId}
                    isCardPreview={previewType === 'card'}
                    isSolutionPreview={previewType === 'solution'}
                    isAnnotationToolOpen={isAnnotationToolOpen}
                    imageZones={imageZones}
                    isReadOnly={!canUserAssess}
                    comments={commentsOnPage}
                    commentsOnPageVisible={commentsOnPageVisible}
                    allCommentsOnPageVisible={allCommentsOnPageVisible}
                    isNewCommentDragging={isNewCommentDragging}
                    onCommentChanged={() => {
                      orgzId && refreshComments(orgzId, examTaskGroupSolutionScoreVersionId);
                    }}
                    canAddComment={canAddCommentOnPage}
                    canEditComment={canEditComment}
                    annotations={annotations ?? []}
                    annotationVersions={annotationVersions ?? []}
                    annotationDefinitions={annotationDefinitions}
                    isActiveAnnotationForGrading={!!activeAnnotationId && isAnnotationForGrading(activeAnnotationId)}
                    onAddAnnotation={(annotation: AnnotationOnImage) => {
                      setAnnotations((prevState) => {
                        return prevState !== null ? [...prevState, annotation] : [annotation];
                      });
                      prevActiveAnnotationId.current = activeAnnotationId;
                      setActiveAnnotationId('');
                    }}
                    onBeforeAddAnnotation={() => {
                      setAnnotationsVisible(true);
                    }}
                    onAnnotationChanged={(updatedAnnotation: AnnotationOnImage[]) => {
                      setAnnotations((prevState) => {
                        return prevState === null
                          ? prevState
                          : prevState.map((item) => {
                              const toUpdate = updatedAnnotation.find((x) => x.annotationId === item.annotationId);
                              if (toUpdate) return toUpdate;
                              return item;
                            });
                      });
                    }}
                    onAnnotationDeleted={(annotation: AnnotationOnImage) => {
                      setAnnotations((prevState) => {
                        const result = prevState
                          ? prevState.filter((item) => item.annotationId !== annotation.annotationId)
                          : prevState;
                        return result;
                      });
                    }}
                    onAnnotationDeactivate={() => setActiveAnnotationId('')}
                    annotationsVisible={(isAnnotationToolOpen && annotationsVisible) || annotationsVisible}
                    activeTask={activeTask ?? null}
                    activeCriterion={activeCriterion}
                    canAddAnnotation={canAddAnnotation}
                    canEditRemoveAnnotation={canEditRemoveAnnotation}
                    activeAnnotationId={activeAnnotationId}
                    sampleExamTaskGroupSolutionScoreState={sampleExamTaskGroupSolutionScoreState}
                    isAnnotationOpenAndDocked={isAnnotationDocked && isAnnotationToolOpen}
                    canvasElementRef={canvasElementRef}
                    examSheetPagesLoaded={examSheetPagesLoaded}
                    imageZonesLoaded={imageZonesLoaded}
                    scoreState={examTaskGroupSolutionWithTasks?.examTaskGroupSolutionScoreState}
                    setIsAnnotationSelected={setIsAnnotationSelected}
                    isAnnotationSelected={isAnnotationSelected}
                    selectPreviousActiveAnnotation={() => {
                      if (
                        prevActiveAnnotationId.current &&
                        annotationDefinitions.find((x) => x.id === prevActiveAnnotationId.current)
                      ) {
                        setActiveAnnotationId(prevActiveAnnotationId.current);
                      }
                    }}
                    isCommentOpen={isCommentsOpen}
                  />
                )}
              </div>
            </div>
            <div
              id="scoringRulesBar"
              style={{
                width: !isSidebarVisible ? 'calc(1px)' : 'calc(20% - 1px)',
                minWidth: !isSidebarVisible ? undefined : '340px',
                height: '100%',
              }}
            >
              {props.mode !== SolutionViewMode.sampleAssessmentGroupAssignment &&
                isContextualHelp &&
                !isFullscreen &&
                isSidebarVisible && (
                  <div style={{ position: 'relative', left: '150px', top: '-15px' }}>
                    <ContextualHelp
                      id={scoringBar}
                      isActive={activatedContextualHelp === scoringBar}
                      onClick={setActivatedContextualHelp}
                      placement={'left'}
                    />
                  </div>
                )}
              {props.mode !== SolutionViewMode.sampleAssessmentGroupAssignment &&
                isContextualHelp &&
                !isFullscreen &&
                isSidebarVisible && (
                  <div style={{ position: 'relative', left: '150px', top: '-15px' }}>
                    <ContextualHelp
                      id={tasksListBar}
                      isActive={activatedContextualHelp === tasksListBar}
                      onClick={setActivatedContextualHelp}
                      placement={'left'}
                    />
                  </div>
                )}
              {props.mode !== SolutionViewMode.sampleAssessmentGroupAssignment &&
                examTaskGroupSolutionWithTasks &&
                !isFullscreen &&
                isContextualHelp &&
                isSidebarVisible && (
                  <div style={{ position: 'relative', left: '150px', top: '-15px' }}>
                    <ContextualHelp
                      id={scoringToolsBar}
                      isActive={activatedContextualHelp === scoringToolsBar}
                      onClick={setActivatedContextualHelp}
                      placement={'left'}
                    />
                  </div>
                )}
              {!isFullscreen && (
                <IconButton
                  className={classes.switchIcon}
                  style={{
                    left: !isSidebarVisible ? 'calc(100% - 70px)' : '',
                  }}
                  onClick={handleSidebarVisibility}
                >
                  {!isSidebarVisible ? (
                    <div onMouseLeave={() => setTimeout(() => setIsTooltipOpen(false), 1500)}>
                      <TooltipOneComponent
                        onMouseOver={() => setIsTooltipOpen(true)}
                        open={isTooltipOpen}
                        title="Zamknij pełny ekran"
                        placement="top"
                        onClick={(e) => e.preventDefault()}
                      >
                        <SwitchOff fill={fillBlue} />
                      </TooltipOneComponent>
                    </div>
                  ) : (
                    <div onMouseLeave={() => setTimeout(() => setIsTooltipOpen(false), 1500)}>
                      <TooltipOneComponent
                        onMouseOver={() => setIsTooltipOpen(true)}
                        open={isTooltipOpen}
                        title="Pełny ekran"
                        placement="top"
                        onClick={(e) => e.preventDefault()}
                      >
                        <SwitchOn fill={fillBlue} />
                      </TooltipOneComponent>
                    </div>
                  )}
                </IconButton>
              )}
              <div style={{ height: '100%', visibility: isSidebarVisible ? 'visible' : 'hidden' }}>
                {examTaskGroupSolutionWithTasks && userFunction !== undefined && (
                  <AssessmentPanel
                    mode={props.mode}
                    fileFullNameExamSheet={fileExamSheetName}
                    examTaskGroupSolutionsNavigation={examTaskGroupSolutionsNavigation}
                    notAssessedExamTaskGroupSolutionsNavigation={notAssessedExamTaskGroupSolutionsNavigation}
                    examinerFunction={userFunction}
                    isSpecialCaseReported={isSpecialCaseReported}
                    chosenViewType={setViewType}
                    schoolId={props.schoolId}
                    examinerId={examinerId}
                    rgzId={props.rgzId}
                    orgzId={orgzId}
                    sampleAssessmentSelectedProcess={sampleAssessmentSelectedProcess}
                    sampleAssessmentSessionStateId={assessmentSession.sampleAssessmentSessionStateId}
                    onSendbackOrConfirmCompleted={handleSendbackOrConfirmCompleted}
                    annotationsVisible={(isAnnotationToolOpen && annotationsVisible) || annotationsVisible}
                    annotationsVisibilityChanged={(newValue: boolean) => setAnnotationsVisible(newValue)}
                    commentsOnPageVisible={commentsOnPageVisible}
                    commentsOnPageVisibilityChanged={(newValue: boolean) => setCommentsOnPageVisible(newValue)}
                    allCommentsOnPageVisible={allCommentsOnPageVisible}
                    allCommentsOnPageVisibilityChanged={(newValue: boolean) => setAllCommentsOnPageVisible(newValue)}
                    checkIfUserCanEditScore={checkIfUserCanEditScore}
                    gradingAnnotationAddedToCriterion={gradingAnnotationAddedToCriterion}
                    anyAnnotationForGradingProvided={anyAnnotationForGradingProvided}
                    isFullscreen={isFullscreen}
                    isAnyModalOpened={isAnyModalOpened}
                    examTaskGroupSolutionsList={examTaskGroupSolutionsList}
                    onCommentChanged={() => {
                      orgzId && refreshComments(orgzId, examTaskGroupSolutionScoreVersionId);
                    }}
                    keyboardShortcutsDisabled={isAnnotationSelected}
                    isSkipLink={isSkipLink}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {downloadLimitModalOpen && processTypeId !== undefined && (
        <DownloadLimitModal
          open={downloadLimitModalOpen}
          isCardLimit={examTaskGroupSolutionStatus === ExamTaskGroupSolutionStatus.NoneExceededLimits}
          noMoreCards={examTaskGroupSolutionStatus === ExamTaskGroupSolutionStatus.NoneNoMoreSolutions}
          processTypeId={parseInt(processTypeId) as AssessmentSessionProcessTypeId}
          handleClose={() => {
            setDownloadLimitModalOpen(false);
          }}
        />
      )}
      {assessmentSessionId && <SessionSuspended assessmentSessionId={assessmentSessionId} />}
      {unreadMessagePrompt.isOpen && (
        <UnreadMessagePrompt
          action={unreadMessagePrompt.actionType}
          unreadConversationType={unreadMessagePrompt.unreadConversationType}
          sheetCodeWithTaskGroupName={getSheetCodeWithTaskGroupName(
            assessmentSession.dashboardSheetCode,
            assessmentSession.examTaskGroupName,
          )}
          onConfirm={(url) => history.push(url)}
        />
      )}
      <NewMessageModal
        open={messageModal.open}
        type={messageModal.type}
        onClose={() => setMessageModal({ open: false, type: 'orgzMessage' })}
        onSend={() => setMessageModal({ open: false, type: 'orgzMessage' })}
        recipientFromOrgz={recipient}
        rgzId={orgzId}
      ></NewMessageModal>
      {props.isTabActive !== false && (
        <LeavePromptRedirectionBlock
          history={history}
          blockingCondition={
            isShelfAssessing || (!!props.tabIndexesWithUnsavedShelf && props.tabIndexesWithUnsavedShelf.length > 0)
          }
        />
      )}
    </>
  );
};

export default Solution;
